
export const version = '5.2';  // 上一版本号3.4.3
export const appstoreVersion = '1.1.9';
export const versionCode = 1;



// WEBPACK FOOTER //
// ./src/version.js